import { ANONYM_USER_PREFIX } from '../constants';

export const isAnonymousUser = (username?: string | null) => Boolean(username?.startsWith(ANONYM_USER_PREFIX));
